import React, { Suspense } from 'react'
import { Await, useLoaderData, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Employer } from '../../interfaces/employer'
import { LocalApiError, SinglePageIdWrapper } from '../../../../components/ui'
import { EmployersForm } from '../employer-form/EmployersForm'
import { employerQuery } from '../../helpers/queries'
import { EmployersHeader } from '../EmployersHeader'

export const EditEmployerLoader = () => {
  const { employer } = useLoaderData() as { employer: Employer }
  const { id } = useParams<{ id: string }>()
  const { data } = useQuery({
    ...employerQuery(id!),
    initialData: employer,
    enabled: !!id
  })
  return (
    <Suspense>
      <SinglePageIdWrapper id={data?.id}>
        <EmployersHeader label="editEmployer" showSearch={false} />
      </SinglePageIdWrapper>
      <Await resolve={employer} errorElement={<LocalApiError message="failedToLoadEmployer" />}>
        {() => <EmployersForm employer={data} method="patch" />}
      </Await>
    </Suspense>
  )
}
